import type { Permission } from "~/models/permission";

export const key = "profile.wallet";

export const permissions: Array<Permission | RegExp> = [];
